import { Invoice } from 'lane-shared/domains/billingPayments/types';

export function isMonthlyInvoice(invoice: Invoice): boolean {

  // Pattern used to determine invoice type. (e.g., monthly invoice or one-off)
  return /^invoice_monthly/i.test(String(invoice.id));
}
